import React, { Component, createContext } from 'react';
import { Base64 } from 'js-base64';

const Context = createContext();
const { Provider, Consumer: ShopConsumer } = Context;

class ShopProvider extends Component {
  state = {
    //messageCount: 0,
    authId: '', //YWRtaW4    //YmFkZ3V5c29u
    aParam: '', //KGBEzGpM   //K-4Uw3HYNouh
    icon: '', //https://file.aniplustv.com/aniplustv/characterImg/chr_blank_s.png
    // apiUrl: 'https://mapi.aniplustv.com:3600',
    apiUrl: 'https://api.aniplustv.com:3100',
    apiUrl2: 'https://mapi.aniplustv.com:3600',
    // apiUrl: 'https://mapi.aniplustv.com:3600',
    apiUrl1: 'https://socket.aniplustv.com:4100',
    aspUrl: 'https://www.aniplustv.com/aniplus2020Api',
    imgUrl: 'https://0i3z252hh7.ecn.cdn.ofs.kr', //'https://www.aniplustv.com', //사이트 내 이미지 경로
    tveeImgUrl: 'https://ah9szoaj9w.ecn.cdn.ofs.kr', //작품관련 이미지 경로(키비쥬얼, 썸네일등등..)
    fileUrl: 'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv',
    //apiUrl: 'http://api.aniplustv.com:3000',
    //viewCookie: '',
    //avata: '',
    data: '',
    nicName: '',
    loginId: '', //admin  //badguyson //nasidayo
    bitrate: '720P',

    downloadBitrate: '720P',
    autoNext: 'Y',
    autoSkip: 'N',
    player: 'IN',
    quickMenu: 'Y',
    //showAlert: false,
    //showAlertTitle: '',
    //showAlertMsg: '',
    //showSnak: false,
    //showSnakMsg: '',
    //showMy: false,
    searchText: '',
    contentSerial: 0,
    playUrl: '',
    timeline: false,
    tvline: false,
    timelineWeek: false,
    cardRegShow: false,
    cardListShow: false,
    memberShipPayEnd: false,
    //cashPayEnd: false,
    orderCode: '',
    channelShow: false,
    updateShow: false,
    eventIdx: 0,
    eventPos: 0,
    tutoralShow: false,
    settingShow: false,
    agreeShow: false,
    board_idx: 0,
    pollIdx: 0,
    showFriend: false,
    pkg: '',
    chatbot: false,
    serviceEndDate: '2024-12-31 23:59:59',
  };

  UNSAFE_componentWillMount = () => {
    const authCookies = this.getCookie('account');
    let authId;
    let loginId;
    let bitrate;
    let download;
    let autoNext;
    let nicName;
    let pkg;
    //console.log(authCookies)

    if (authCookies) {
      const arrAuth = authCookies.split('&');
      //console.log(authCookies.indexOf('&authId'))
      if (authCookies.indexOf('&authId') > -1) {
        if (
          arrAuth[0] === '' ||
          arrAuth[0] === null ||
          arrAuth[0] === undefined ||
          arrAuth[0] === 'playerFlag=H'
        ) {
          //console.log(authCookies)
        } else {
          if (arrAuth.length > 0) {
            arrAuth.sort();
            //console.log(arrAuth)
            //console.log(arrAuth[0])
            authId = arrAuth[0].substring(7, arrAuth[0].length);
            loginId = arrAuth[5].substring(8, arrAuth[0].length);
            nicName = decodeURIComponent(
              arrAuth[6].substring(10, arrAuth[6].length)
            );
            //console.log(nicName)
            const authId1 = Base64.encode(loginId);
            // messageCount_output=>bitrate
            // memberPartCode => download
            // couponCount => autoNext
            bitrate = arrAuth[8].substring(20, arrAuth[8].length);
            download = arrAuth[7].substring(15, arrAuth[7].length);
            autoNext = arrAuth[2].substring(12, arrAuth[2].length);
            pkg = arrAuth[9].substring(4, arrAuth[9].length);
            //console.log(pkg)
            //console.log(bitrate)
            //console.log(download)
            //console.log(autoNext)

            this.setState({
              authId: authId1,
              aParam: authId,
              loginId: loginId,
              bitrate: bitrate,
              donwloadBitrate: download,
              autoNext: autoNext,
              nicName: nicName,
              pkg: pkg,
            });
            //this._getMemberInfo(authId);
            //this.getCartCount(authId);
          }
        }
      }
    }
  };
  actions = {
    setAuthId: (authId) => {
      this.setState({
        authId: authId,
      });
    },
    setLoginId: (loginId) => {
      this.setState({
        loginId: loginId,
      });
    },
    setAParam: (aParam) => {
      this.setState({
        aParam: aParam,
      });
    },
    setIcon: (icon) => {
      this.setState({
        icon: icon,
      });
    },
    setData: (data) => {
      this.setState({
        data: data,
      });
    },

    setBitrate: (bit) => {
      this.setState({
        bitrate: bit,
      });
    },
    setDownloadBitrate: (bit) => {
      this.setState({
        downloadBitrate: bit,
      });
    },
    setAutoNext: (val) => {
      this.setState({
        autoNext: val,
      });
    },
    setAutoSkip: (val) => {
      this.setState({
        autoSkip: val,
      });
    },
    setPlayer: (val) => {
      this.setState({
        player: val,
      });
    },
    setQuickMenu: (val) => {
      this.setState({
        quickMenu: val,
      });
    },
    setNicName: (nicName) => {
      this.setState({
        nicName: nicName,
      });
    },

    setContentSerial: (val) => {
      if (val === 0) {
        document.body.style.overflowY = 'scroll';
      } else {
        document.body.style.overflowY = 'hidden';
      }

      this.setState({
        contentSerial: val,
      });
    },
    setEventIdx: (val, pos) => {
      //console.log('aaa')
      //console.log(pos)
      if (val === 0) {
        document.body.style.overflowY = 'scroll';
      } else {
        document.body.style.overflowY = 'hidden';
      }

      this.setState({
        eventIdx: val,
        eventPos: pos === null || pos === undefined || pos === '' ? 0 : pos,
      });
    },
    setPlayUrl: (val) => {
      if (val === '' || val === null || val === undefined) {
        document.body.style.overflowY = 'scroll';
      } else {
        document.body.style.overflowY = 'hidden';
      }

      this.setState({
        playUrl: val,
      });
    },
    setTimeline: (val) => {
      this.setState({
        timeline: val,
      });
    },
    setTvline: (val) => {
      this.setState({
        tvline: val,
      });
    },
    setTimelineWeek: (val) => {
      this.setState({
        timelineWeek: val,
      });
    },
    setUpdateShow: (val) => {
      this.setState({
        updateShow: val,
      });
    },
    setCartCount: (messageCount) => {
      this.setState({
        messageCount: messageCount,
      });
    },
    setViewCookie: (viewCookie) => {
      this.setState({
        viewCookie: viewCookie,
      });
    },
    setAvata: (avata) => {
      this.setState({
        avata: avata,
      });
    },
    // setNicName: (nicName) => {
    //   this.setState({
    //     nicName: nicName,
    //   });
    // },
    setShowAlert: (value, title, msg) => {
      this.setState({
        showAlert: value,
        showAlertTitle: title,
        showAlertMsg: msg,
      });
    },
    setShowSnak: (value, msg) => {
      this.setState({
        showSnak: value,
        showSnakMsg: msg,
      });
    },
    setShowMy: (value) => {
      this.setState({
        showMy: value,
      });
    },
    setSearchText: (value) => {
      this.setState({
        searchText: value,
      });
    },
    setCardRegShow: (value) => {
      this.setState({
        cardRegShow: value,
      });
    },
    setCardListShow: (value) => {
      this.setState({
        cardListShow: value,
      });
    },
    setMemberShipPayEnd: (value, orderCode) => {
      this.setState({
        memberShipPayEnd: value,
        orderCode: orderCode,
      });
    },
    setChannelShow: (value) => {
      this.setState({
        channelShow: value,
      });
    },
    setTutorialShow: (value) => {
      if (value) {
        document.body.style.overflowY = 'hidden';
      } else {
        document.body.style.overflowY = 'scroll';
      }
      this.setState({
        tutorialShow: value,
      });
    },
    setSettingShow: (value) => {
      //console.log(value)
      this.setState({
        settingShow: value,
      });
    },
    setAgreeShow: (value) => {
      this.setState({
        agreeShow: value,
      });
    },
    setPollShow: (value) => {
      this.setState({
        pollIdx: value,
      });
    },
    setBoardIdx: (val) => {
      if (val === 0) {
        document.body.style.overflowY = 'scroll';
      } else {
        document.body.style.overflowY = 'hidden';
      }

      this.setState({
        board_idx: val,
      });
    },
    setShowFriend: (val) => {
      this.setState({
        showFriend: val,
      });
    },
    setPkg: (val) => {
      this.setState({
        pkg: val,
      });
    },
    setChatbot: (val) => {
      this.setState({
        chatbot: val,
      });
    },
    /*
        setCashPayEnd: (value) => {
            this.setState({
                cashPayEnd: value
            })
        }
        */
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value ? value[2] : null;
  };

  render() {
    const { state, actions } = this;
    const value = { state, actions };

    return <Provider value={value}>{this.props.children}</Provider>;
  }
}

//HoC 를 사용
function shopContext(WrappedComponent) {
  const randomNum = 1;
  // const randomNum = Math.floor(Math.random() * 2 + 1);

  // console.log(randomNum);
  return function ShopContext(props) {
    return (
      <ShopConsumer>
        {({ state, actions }) => (
          <WrappedComponent
            //value={state.value}
            //cartCount={state.cartCount}
            authId={state.authId}
            aParam={state.aParam}
            loginId={state.loginId}
            apiUrl={randomNum === 1 ? state.apiUrl : state.apiUrl2}
            apiUrl1={state.apiUrl1}
            aspUrl={state.aspUrl}
            data={state.data}
            imgUrl={state.imgUrl}
            tveeImgUrl={state.tveeImgUrl}
            fileUrl={state.fileUrl}
            bitrate={state.bitrate}
            downloadBitrate={state.downloadBitrate}
            autoNext={state.autoNext}
            autoSkip={state.autoSkip}
            quickMenu={state.quickMenu}
            icon={state.icon}
            player={state.player}
            nicName={state.nicName}
            contentSerial={state.contentSerial}
            playUrl={state.playUrl}
            timeline={state.timeline}
            tvline={state.tvline}
            timelineWeek={state.timelineWeek}
            cardRegShow={state.cardRegShow}
            cardListShow={state.cardListShow}
            memberShipPayEnd={state.memberShipPayEnd}
            //cashPayEnd={state.cashPayEnd}
            orderCode={state.orderCode}
            channelShow={state.channelShow}
            updateShow={state.updateShow}
            eventIdx={state.eventIdx}
            eventPos={state.eventPos}
            tutorialShow={state.tutorialShow}
            settingShow={state.settingShow}
            agreeShow={state.agreeShow}
            pollIdx={state.pollIdx}
            board_idx={state.board_idx}
            showFriend={state.showFriend}
            pkg={state.pkg}
            chatbot={state.chatbot}
            serviceEndDate={state.serviceEndDate}
            setAuthId={actions.setAuthId}
            setAParam={actions.setAParam}
            setLoginId={actions.setLoginId}
            setIcon={actions.setIcon}
            setData={actions.setData}
            setBitrate={actions.setBitrate}
            setDownloadBitrate={actions.setDownloadBitrate}
            setAutoNext={actions.setAutoNext}
            setAutoSkip={actions.setAutoSkip}
            setPlayer={actions.setPlayer}
            setNicName={actions.setNicName}
            setQuickMenu={actions.setQuickMenu}
            setContentSerial={actions.setContentSerial}
            setPlayUrl={actions.setPlayUrl}
            setTimeline={actions.setTimeline}
            setTvline={actions.setTvline}
            setTimelineWeek={actions.setTimelineWeek}
            setUpdateShow={actions.setUpdateShow}
            setCardRegShow={actions.setCardRegShow}
            setCardListShow={actions.setCardListShow}
            setMemberShipPayEnd={actions.setMemberShipPayEnd}
            setChannelShow={actions.setChannelShow}
            setEventIdx={actions.setEventIdx}
            setTutorialShow={actions.setTutorialShow}
            setSettingShow={actions.setSettingShow}
            setAgreeShow={actions.setAgreeShow}
            setPollShow={actions.setPollShow}
            setBoardIdx={actions.setBoardIdx}
            setShowFriend={actions.setShowFriend}
            setPkg={actions.setPkg}
            setChatbot={actions.setChatbot}
            //setCashPayEnd={actions.setCashPayEnd}
            //viewCookie={state.viewCookie}
            /*
                            avata={state.avata}
                            nicName={state.nicName}
                            showAlert={state.showAlert}
                            showAlertTitle={state.showAlertTitle}
                            showAlertMsg={state.showAlertMsg}
                            showSnak={state.showSnak} 
                            showSnakMsg={state.showSnakMsg}
                            showMy={state.showMy}
                            searchText={state.searchText}
                            setValue={actions.setValue}
                            setCartCount={actions.setCartCount}
                            setAuthId={actions.setAuthId}
                            setLoginId={actions.setLoginId}
                            //setViewCookie={actions.setViewCookie}
                            setAvata={actions.setAvata}
                            setNicName={actions.setNicName}
                            setShowAlert={actions.setShowAlert}
                            setShowSnak={actions.setShowSnak}
                            setShowMy={actions.setShowMy}
                            setSearchText={actions.setSearchText}
                            */
            childProps={props}
          />
        )}
      </ShopConsumer>
    );
  };
}

export { ShopProvider, ShopConsumer, shopContext };
